module.exports = __webpack_public_path__ + "static/media/dynamometerEn.5edc63e9.png";